/** Carte « Expert en sinistre de l'assureur adverse » + envoi en 1 clic à mon expert (ex. Valencia Fortin). */
import { useState } from "react";
import { toast } from "sonner";
import { Send, Save, UserSearch, Loader2 } from "lucide-react";
import { api } from "../lib/api";

const inp = "w-full bg-zinc-800 border border-zinc-700 rounded px-2.5 py-1.5 text-sm text-zinc-100";
const emailIn = (t) => ((t || "").match(/[\w.+-]+@[\w-]+\.[\w.-]+/) || [""])[0];

export default function SinistreAdverseCard({ claim, onSaved }) {
  const [f, setF] = useState({
    liability_insurer: claim.liability_insurer || "", liability_adjuster: claim.liability_adjuster || "",
    adverse_adjuster_phone: claim.adverse_adjuster_phone || "", adverse_adjuster_email: claim.adverse_adjuster_email || emailIn(claim.liability_adjuster_contact),
    liability_claim_number: claim.liability_claim_number || "", adverse_adjuster_company_file: claim.adverse_adjuster_company_file || "",
  });
  const [to, setTo] = useState(emailIn(claim.expert_contact) || "valencia.fortin@dgag.ca");
  const [busy, setBusy] = useState("");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const save = async () => {
    setBusy("save");
    try { await api.put(`/dossier-sinistre/${claim.id}`, { ...f, liability_adjuster_contact: [f.adverse_adjuster_phone, f.adverse_adjuster_email].filter(Boolean).join(" · ") }); toast.success("Expert adverse enregistré ✓"); onSaved && onSaved(); }
    catch { toast.error("Erreur d'enregistrement"); } finally { setBusy(""); }
  };
  const send = async () => {
    if (!f.liability_adjuster && !f.liability_insurer) return toast.error("Renseigne au moins le nom de l'expert ou de l'assureur adverse.");
    if (!/@/.test(to)) return toast.error("Courriel du destinataire invalide.");
    setBusy("send");
    try {
      await save();
      const body = [
        `Bonjour ${(claim.expert_name || "").split(" ")[0] || ""},`.replace(" ,", ","), "",
        `Voici les informations de l'expert en sinistre de l'assureur adverse pour le dossier ${claim.claim_number || ""} (${claim.property_address || ""}) :`, "",
        `• Assureur adverse : ${f.liability_insurer || "—"}`,
        `• Expert en sinistre : ${f.liability_adjuster || "—"}`,
        `• Téléphone : ${f.adverse_adjuster_phone || "—"}`,
        `• Courriel : ${f.adverse_adjuster_email || "—"}`,
        `• N° de dossier chez l'assureur adverse : ${f.liability_claim_number || "—"}`,
        f.adverse_adjuster_company_file ? `• Référence / notes : ${f.adverse_adjuster_company_file}` : null, "",
        "Le formulaire « claim experience » (reconstruction) complété suit dans un envoi séparé.", "",
        "Cordialement,", claim.owner_name || "Ralph David Jean-Pierre", claim.owner_contact || "",
      ].filter((l) => l !== null).join("\n");
      await api.post(`/dossier-sinistre/${claim.id}/send-custom`, { to_email: to, subject: `Dossier ${claim.claim_number || ""} — Informations de l'expert de l'assureur adverse`, body_text: body, include_pdf: false });
      toast.success(`Courriel envoyé à ${to} ✓`); onSaved && onSaved();
    } catch (e) { toast.error(e?.response?.data?.detail || "Envoi impossible (quota courriel ?)"); } finally { setBusy(""); }
  };

  return (
    <div className="rounded-xl border border-amber-500/40 bg-amber-500/5 p-4 space-y-3" data-testid="adverse-card">
      <div className="text-sm font-semibold text-amber-300 flex items-center gap-2"><UserSearch size={15} /> Expert en sinistre de l'assureur adverse <span className="text-xs font-normal text-zinc-400">— demandé par ton assureur</span></div>
      <div className="grid sm:grid-cols-3 gap-2">
        {[["liability_insurer", "Assureur adverse (compagnie)"], ["liability_adjuster", "Nom de l'expert"], ["liability_claim_number", "N° dossier chez l'adverse"],
          ["adverse_adjuster_phone", "Téléphone"], ["adverse_adjuster_email", "Courriel"], ["adverse_adjuster_company_file", "Référence / notes"]].map(([k, l]) => (
          <label key={k} className="text-[11px] text-zinc-400">{l}<input value={f[k]} onChange={set(k)} data-testid={`adverse-${k}`} className={inp} /></label>
        ))}
      </div>
      <div className="flex flex-wrap items-end gap-2">
        <label className="text-[11px] text-zinc-400 flex-1 min-w-[240px]">Envoyer à (mon expert)<input value={to} onChange={(e) => setTo(e.target.value)} data-testid="adverse-to" className={inp} /></label>
        <button onClick={save} disabled={!!busy} data-testid="adverse-save" className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg bg-zinc-800 hover:bg-zinc-700 text-sm text-zinc-100">{busy === "save" ? <Loader2 size={14} className="animate-spin" /> : <Save size={14} />} Enregistrer</button>
        <button onClick={send} disabled={!!busy} data-testid="adverse-send" className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg bg-amber-500 hover:bg-amber-400 text-black text-sm font-semibold">{busy === "send" ? <Loader2 size={14} className="animate-spin" /> : <Send size={14} />} Envoyer à {to.split("@")[0] || "l'expert"} en 1 clic</button>
      </div>
    </div>
  );
}
